"use client";

import { PopupOddCell } from "./PopupOddCell";
import {
  cellText,
  tdBorderRightAfterThirdColumn,
  trendForHandicapOrOverUnder,
  trendForOneXTwo,
} from "./oddsPopupHelpers";
import {
  oddsDetailTableClass,
  labelCellClass,
  grayHeaderCellClass,
  tdSepRight,
} from "./oddsPopupStyles";

const COLUMN_COUNT = 10;

function tripleGroupsFromBlock(block) {
  return [block.live, block.compare, block.early];
}

function MarketLabelCell({ children }) {
  return (
    <td className={labelCellClass}>
      <p className="m-0">
        <strong>{children}</strong>
      </p>
    </td>
  );
}

function GroupHeaderRow({ periodLabel }) {
  return (
    <tr>
      <td className={labelCellClass}>{periodLabel}</td>
      <td colSpan={3} className={grayHeaderCellClass} style={tdSepRight}>
        Trực tiếp
      </td>
      <td colSpan={3} className={grayHeaderCellClass} style={tdSepRight}>
        TL
      </td>
      <td colSpan={3} className={grayHeaderCellClass}>
        Sớm
      </td>
    </tr>
  );
}

function OddsMarketRow({ rowKey, title, block, resolveTrend }) {
  return (
    <tr>
      <MarketLabelCell>{title}</MarketLabelCell>
      {tripleGroupsFromBlock(block).flatMap((tripleValues, groupIndex) =>
        tripleValues.map((cellValue, cellIndex) => {
          const borderRight = tdBorderRightAfterThirdColumn(groupIndex, cellIndex) ? tdSepRight : undefined;
          const trend = resolveTrend(block.trends, groupIndex, cellIndex);
          return (
            <td key={`${rowKey}-${groupIndex}-${cellIndex}`} className="min-w-0" style={borderRight}>
              <PopupOddCell trend={trend}>{cellText(cellValue)}</PopupOddCell>
            </td>
          );
        }),
      )}
    </tr>
  );
}

export function OddsDetailTable({ periodLabel, hdp, ou, x12 }) {
  const tableExtraClass = periodLabel === "FT" ? "mb-[5px]" : "";
  const cellSpacing = periodLabel === "HT" ? 1 : 0;

  return (
    <table
      className={`${oddsDetailTableClass} ${tableExtraClass}`}
      cellPadding="0"
      cellSpacing={cellSpacing}
      border="0"
    >
      <colgroup>
        <col className="w-[3.25rem] min-w-0" />
        {Array.from({ length: COLUMN_COUNT - 1 }, (_, i) => (
          <col key={i} className="min-w-0" />
        ))}
      </colgroup>
      <tbody>
        <GroupHeaderRow periodLabel={periodLabel} />

        <OddsMarketRow
          rowKey="hdp"
          title="HDP"
          block={hdp}
          resolveTrend={trendForHandicapOrOverUnder}
        />
        <OddsMarketRow
          rowKey="ou"
          title="O/U"
          block={ou}
          resolveTrend={trendForHandicapOrOverUnder}
        />
        <OddsMarketRow
          rowKey="x12"
          title="1x2"
          block={x12}
          resolveTrend={trendForOneXTwo}
        />

        <tr>
          <td colSpan={COLUMN_COUNT} className="p-1" />
        </tr>
      </tbody>
    </table>
  );
}
